import { createSelector } from 'reselect';
import { compose } from 'redux';

export const getSearch = compose(
  ({ search }) => search,
  (state) => state
);

export const getSearchValue = compose(({ value }) => value, getSearch);
export const getSearchValueState = compose(({ isLoading }) => isLoading, getSearch);
export const getSearchRequestFetchStatus = compose(({ isFetched }) => isFetched, getSearch);
export const getSearchModalState = compose(({ isSearchModalOpen }) => isSearchModalOpen, getSearch);

export const getSearchAutocomplete = compose(({ autocomplete }) => autocomplete, getSearch);

export const getRegions = compose(({ regions }) => regions, getSearchAutocomplete);

export const getSubregions = compose(({ subregions }) => subregions, getSearchAutocomplete);

export const getBuildings = compose(({ buildings }) => buildings, getSearchAutocomplete);

export const getStreets = compose(({ streets }) => streets, getSearchAutocomplete);



// WEBPACK FOOTER //
// ./src/selectors/search.js